import * as Sentry from '@sentry/browser';
import SRError from '~/utils/errors/srError';
import { sentryInitNoConfig } from './observability/sentry';

export interface HandleInitErrorParams {
    error: unknown;
}

export function handleInitError({ error }: HandleInitErrorParams) {
    if (!Sentry.isInitialized()) {
        sentryInitNoConfig();
    }
    Sentry.captureMessage(`Init error: ${error}`);

    if (error instanceof SRError) {
        console.error(error.toString());
        return;
    }

    console.error(error);
}
